<app-control-layout
    [control]="formCtrl"
    [label]="label"
    [ignoreLabel]="ignoreLabel"
    [permission]="permission"
    [labelBlock]="labelBlock"
    [width]="width"
    [maxLength]="maxLength"
    [verticallyAlign]="false"
    [attr.id] ="idName">
    <textarea #someVar class="form_input"
        [formControl]="formCtrl"
        [attr.id] = "idName"
        [style.width]="labelBlock ? 'calc(100% - 140px)' : '100%'"
        [ngClass]="{'border-danger' : control?.errors?.required && (control?.touched || externalTrigger)}"
        [maxLength]="maxLength">
    </textarea>
</app-control-layout>

